module.exports = __webpack_public_path__ + "img/DTT_HH_2022-KeyVisual-TopView.4060850f.png";